const jobSearchGlobal = {
  config: {
    general: {
      corners: {
        label: "Round",
        value: "round",
      },
      accentColor: {
        label: "Custom 1",
        value: "#2F79FF",
      },
      pageBackgroundColor: {
        label: "Default White",
        value: "#fff",
      },
      theme: {
        label: "Light",
        value: "default-light", // or default-dark
      },
    },
    applyButton: {
      text: "Apply",
      fillStyle: {
        label: "Fill",
        value: "fill",
      },
      corners: {
        label: "Round",
        value: "round",
      },
      backgroundColor: {
        label: "Blue",
        value: "#489CDC",
      },
      textColor: {
        label: "White",
        value: "#fff",
      },
    },
    filters: {
      options: [
        {
          active: true,
          key: "company",
          label: "Company",
          visibleOnCards: false,
          type: "list",
        },
        {
          active: true,
          key: "department",
          label: "Department",
          visibleOnCards: true,
          type: "list",
        },
        {
          active: true,
          key: "location",
          label: "Location",
          visibleOnCards: true,
          type: "location",
        },
        {
          active: true,
          key: "schedule",
          label: "Schedule",
          visibleOnCards: true,
          type: "select",
        },
        {
          active: true,
          key: "start_year",
          label: "Start Year",
          visibleOnCards: false,
          type: "slider",
        },
        {
          active: true,
          key: "career_level",
          label: "Career Level",
          visibleOnCards: false,
          type: "list",
        },
        {
          active: true,
          key: "salary",
          label: "Salary",
          visibleOnCards: false,
          type: "slider",
        },
        {
          active: true,
          key: "working_hours",
          label: "Working Hours",
          visibleOnCards: true,
          type: "list",
        },
        {
          active: true,
          key: "work_mode",
          label: "Work Mode",
          visibleOnCards: false,
          type: "select",
        },
      ],
      resetButtonsText: {
        singleFilter: "Clear filter",
        allFilters: "Clear all filters",
      },
      emptyStateText:
        "There are no filters that match your requests. Please try again.",
      placeholderText: "Search options here...",
      backToResultsText: "Back to search results",
      nationwideText: "Nationwide",
    },
    sorting: {
      text: "Sort by:",
      items: [
        { label: "Default", value: "offers" },
        { label: "A-Z", value: "offers/sort/title:asc" },
        { label: "Z-A", value: "offers/sort/title:desc" },
        {
          label: "Date (asc)",
          value: "offers/sort/start_date_timestamp:asc",
        },
        {
          label: "Date (desc)",
          value: "offers/sort/start_date_timestamp:desc",
        },
      ],
    },
    search: {
      placeholderText: "Search for a position, location, role, etc.",
    },
    results: {
      emptyState: {
        headline: "No results found.",
        subline: "Your search did not match any jobs. Please try again.",
      },
      amountHitsText: "job(s)",
      showFullAddress: false,
    },
    map: {
      showMap: true,
      mapStyle: {
        label: "Light",
        value: "light", // light, dark, white, grayscale, black
      },
      markerColor: {
        label: "Blue",
        value: "#489CDC",
      },
    },
  },
};

export default jobSearchGlobal;
